import React, { useState, useEffect } from "react";
import { globalFileServer } from "../../axiosInstance";
import $ from "jquery";
import { X, Accessibility as AccessibilityIcon } from "lucide-react";

const pluses = /\+/g;
const config = {};

const Footer = () => {
  const [accessibilityOpen, setAccessibilityOpen] = useState(false);
  const [linksUnderlined, setLinksUnderlined] = useState(false);
  const [linksBolded, setLinksBolded] = useState(false);

  useEffect(() => {
    onLoadPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (linksUnderlined) {
      $("body").addClass("links-underlined");
    } else {
      $("body").removeClass("links-underlined");
    }
  }, [linksUnderlined]);

  useEffect(() => {
    if (linksBolded) {
      $("body").addClass("links-bolded");
    } else {
      $("body").removeClass("links-bolded");
    }
  }, [linksBolded]);

  const setCookie = (key, value) => {
    if (value !== undefined) {
      const options = $.extend({}, config.defaults);
      if (typeof options.expires === "number") {
        const days = options.expires,
          t = (options.expires = new Date());
        t.setTime(+t + days * 864e5);
      }
      return (document.cookie = [
        encodeURIComponent(key),
        "=",
        config.raw ? value : encodeURIComponent(value),
        options.expires ? "; expires=" + options.expires.toUTCString() : "",
        options.path ? "; path=" + options.path : "",
        options.domain ? "; domain=" + options.domain : "",
        options.secure ? "; secure" : "",
      ].join(""));
    }

    let result = key ? undefined : {};
    let cookies = document.cookie ? document.cookie.split("; ") : [];
    for (let i = 0; i < cookies.length; i++) {
      let parts = cookies[i].split("=");
      let name = decode(parts.shift());
      let cookie = parts.join("=");
      if (key === name) {
        result = read(cookie);
        break;
      }
      if (!key && (cookie = read(cookie)) !== undefined) {
        result[name] = cookie;
      }
    }
    return result;
  };

  const removeCookie = (key) => {
    setCookie(key, "", { expires: -1, path: "/" });
    return !setCookie(key);
  };

  const decode = (s) => {
    return config.raw ? s : decodeURIComponent(s);
  };

  const parseCookieValue = (s) => {
    if (s.indexOf('"') === 0) {
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
    }
    try {
      s = decodeURIComponent(s.replace(pluses, " "));
      return config.json ? JSON.parse(s) : s;
    } catch {}
  };

  const read = (s, converter) => {
    const value = config.raw ? s : parseCookieValue(s);
    return $.isFunction(converter) ? converter(value) : value;
  };

  const openAccessibility = () => {
    if (accessibilityOpen) {
      $(".accessibility").slideUp();
    } else {
      $(".accessibility").slideDown();
    }
    setAccessibilityOpen(!accessibilityOpen);
  };

  const onLoadPage = () => {
    const savedBodyClass = setCookie("bodyClass");
    if (savedBodyClass) {
      $("body").addClass(savedBodyClass);
    }

    const savedZoom = setCookie("bodyZoom");
    if (savedZoom) {
      $("body").addClass(savedZoom);
    }

    const savedGrayscale = setCookie("bodyGrayscale");
    if (savedGrayscale) {
      document.documentElement.classList.add("grayscale_body");
    }

    const savedInvert = setCookie("bodyInvert");
    if (savedInvert) {
      document.documentElement.classList.add("invert_body");
    }

    const savedLinks = setCookie("bodyLinks");
    if (savedLinks) {
      setLinksUnderlined(true);
    }

    const savedBold = setCookie("bodyLinksBold");
    if (savedBold) {
      setLinksBolded(true);
    }

    applyFontSizeScaling();
  };

  const decrease_links = () => {
    setLinksBolded(true);
    setCookie("bodyLinksBold", "links_bolded");
  };

  const increase_links = () => {
    setLinksUnderlined(true);
    setCookie("bodyLinks", "links-underlined");
  };

  const increase_fs = () => {
    const body = $("body");
    if (body.hasClass("sizeL")) {
      body.removeClass("sizeL").addClass("sizeXL");
      setCookie("bodyClass", "sizeXL");
    } else if (body.hasClass("sizeXL")) {
      body.removeClass("sizeXL").addClass("sizeXXL");
      setCookie("bodyClass", "sizeXXL");
    } else if (body.hasClass("sizeXXL")) {
      body.removeClass("sizeXXL").addClass("sizeXXXL");
      setCookie("bodyClass", "sizeXXXL");
    } else {
      body.addClass("sizeL");
      setCookie("bodyClass", "sizeL");
    }
    applyFontSizeScaling();
  };

  const decrease_fs = () => {
    const body = $("body");
    if (body.hasClass("sizeXXXL")) {
      body.removeClass("sizeXXXL").addClass("sizeXXL");
      setCookie("bodyClass", "sizeXXL");
    } else if (body.hasClass("sizeXXL")) {
      body.removeClass("sizeXXL").addClass("sizeXL");
      setCookie("bodyClass", "sizeXL");
    } else if (body.hasClass("sizeXL")) {
      body.removeClass("sizeXL").addClass("sizeL");
      setCookie("bodyClass", "sizeL");
    } else if (body.hasClass("sizeL")) {
      body.removeClass("sizeL");
      removeCookie("bodyClass");
    }
    applyFontSizeScaling();
  };

  const applyFontSizeScaling = () => {
    const body = $("body");
    let scale = 1;

    if (body.hasClass("sizeL")) scale = 1.07;
    else if (body.hasClass("sizeXL")) scale = 1.14;
    else if (body.hasClass("sizeXXL")) scale = 1.21;
    else if (body.hasClass("sizeXXXL")) scale = 1.28;

    $("*")
      .not(
        `
        .accessibility-wrapper, .accessibility-wrapper *, 
        .header-wrapper, .header-wrapper *,
        .smart-scroll-row, .smart-scroll-row *,
        nav, nav *, footer, footer *
    `,
      )
      .each(function () {
        const element = $(this);

        if (!element.data("originalFontSize")) {
          const computedStyle = window.getComputedStyle(this);
          const originalSize = parseFloat(computedStyle.fontSize);
          if (originalSize) {
            element.data("originalFontSize", originalSize);
          }
        }

        const originalSize = element.data("originalFontSize");
        if (originalSize) {
          const newSize = originalSize * scale;
          element.css("font-size", newSize + "px");
        }
      });
  };

  const invert_body = () => {
    restore_color_body();
    document.documentElement.classList.add("invert_body");
    setCookie("bodyInvert", "invert_body");
  };

  const grayscale_body = () => {
    restore_color_body();
    document.documentElement.classList.add("grayscale_body");
    setCookie("bodyGrayscale", "grayscale_body");
  };

  const restore_color_body = () => {
    document.documentElement.classList.remove("grayscale_body", "invert_body");
    $("body").removeClass("grayscale_body invert_body");
    removeCookie("bodyGrayscale");
    removeCookie("bodyInvert");
  };

  const restore_fs = () => {
    $("body").removeClass("sizeL sizeXL sizeXXL sizeXXXL");
    removeCookie("bodyClass");
    $("*").css("font-size", "");
    applyFontSizeScaling();
  };

  const zoom_in_body = () => {
    if ($("body").hasClass("zoomL")) {
      $("body").removeClass("zoomL").addClass("zoomXL");
      setCookie("bodyZoom", "zoomXL");
    } else if ($("body").hasClass("zoomXL")) {
      $("body").removeClass("zoomXL").addClass("zoomXXL");
      setCookie("bodyZoom", "zoomXXL");
    } else {
      $("body").addClass("zoomL");
      setCookie("bodyZoom", "zoomL");
    }
  };
  const zoom_out_body = () => {
    if ($("body").hasClass("zoomXXL")) {
      $("body").removeClass("zoomXXL").addClass("zoomXL");
      removeCookie("bodyZoom");
      setCookie("bodyZoom", "zoomXL");
    } else if ($("body").hasClass("zoomXL")) {
      $("body").removeClass("zoomXL").addClass("zoomL");
      removeCookie("bodyZoom");
      setCookie("bodyZoom", "zoomL");
    } else if ($("body").hasClass("zoomL")) {
      $("body").removeClass("zoomL");
      removeCookie("bodyZoom");
    }
  };

  const restore_zoom_body = () => {
    if ($("body").hasClass("zoomXXL")) {
      $("body").removeClass("zoomXXL");
    }
    if ($("body").hasClass("zoomXL")) {
      $("body").removeClass("zoomXL");
    }
    if ($("body").hasClass("zoomL")) {
      $("body").removeClass("zoomL");
    }
    removeCookie("bodyZoom");
  };
  const restore_links = () => {
    setLinksUnderlined(false);
    setLinksBolded(false);
    removeCookie("bodyLinks");
    removeCookie("bodyLinksBold");
  };

  return (
    <>
      {/* Trigger button — rendered as a direct flex child of the pill nav */}
      <button
        type="button"
        className="nav-pill-btn nav-pill-btn--icon-only"
        onClick={openAccessibility}
        aria-label="נגישות"
        aria-expanded={accessibilityOpen}
      >
        <AccessibilityIcon size={18} strokeWidth={2} aria-hidden />
        <span>נגישות</span>
      </button>

      {/* Panel — position:fixed overlay, out of flow */}
      <div className="accessibility-wrapper">
        <div className="accessibility">
          <div className="accessibility-contant flex-container">
            <div className="col-lg-3">
              <h3>גודל הגופן</h3>
              <ul>
                <li onClick={increase_fs}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/text_increase.svg"}
                      alt="increase-font"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    הגדל גופן
                  </a>
                </li>
                <li onClick={decrease_fs}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/text_decrease.svg"}
                      alt="decrease-font"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    הקטן גופן
                  </a>
                </li>
                <li onClick={restore_fs}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/refresh.svg"}
                      alt="generic-text"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    שחזר את גודל הגופן
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-zoom">
              <h3>תצוגה</h3>
              <ul>
                <li onClick={zoom_in_body}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/zoom_in.svg"}
                      alt="zoom-in"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    הגדל את התצוגה
                  </a>
                </li>
                <li onClick={zoom_out_body}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/zoom_out.svg"}
                      alt="zoom-out"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    הקטן את התצוגה
                  </a>
                </li>
                <li onClick={restore_zoom_body}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/refresh.svg"}
                      alt="refresh"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    שחזר תצוגה
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-3">
              <h3>צבעוניות</h3>
              <ul>
                <li onClick={grayscale_body}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/contrast.svg"}
                      alt="black-white"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    שחור לבן
                  </a>
                </li>
                <li onClick={invert_body}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/palette.svg"}
                      alt="contrast"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    הפוך צבעים
                  </a>
                </li>
                <li onClick={restore_color_body}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/refresh.svg"}
                      alt="refresh"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    שחזר צבעים
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-3">
              <h3>לינקים</h3>
              <ul>
                <li onClick={increase_links}>
                  <span>
                    <img
                      loading="lazy"
                      src={
                        globalFileServer + "accessibility/format_underlined.svg"
                      }
                      alt="underline"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    קו מתחת ללינקים
                  </a>
                </li>
                <li onClick={decrease_links}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/format_bold.svg"}
                      alt="bold"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    הדגש לינקים
                  </a>
                </li>
                <li onClick={restore_links}>
                  <span>
                    <img
                      loading="lazy"
                      src={globalFileServer + "accessibility/refresh.svg"}
                      alt="refresh"
                    />
                  </span>{" "}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    שחזר לינקים
                  </a>
                </li>
              </ul>
            </div>
            <div className="close-accessibility">
              <button
                type="button"
                className="accessibility-icon-btn accessibility-icon-btn--close"
                onClick={openAccessibility}
                aria-label="סגור"
              >
                <X size={18} strokeWidth={2} />
              </button>
            </div>
          </div>
          <div className="accessibility-footer"></div>
        </div>
      </div>
    </>
  );
};

export default Footer;
